import script from "./ProviderDefaultCommunicationMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderDefaultCommunicationMethod.vue?vue&type=script&setup=true&lang=js"

import "./ProviderDefaultCommunicationMethod.vue?vue&type=style&index=0&id=6423478c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6423478c"]])

export default __exports__